/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

import angular from 'angular';
import { appStates } from './app-state.constants';

angular.module('avi/app')
    .constant('appStateConstants', appStates);
